import { Icon } from '@chakra-ui/icon';
import { Box, Flex, Text } from '@chakra-ui/layout';
import { useColorModeValue } from '@chakra-ui/react';
import {
	IconDownload,
	IconFilePlus,
	IconLogin,
	IconLogout,
	IconPlus,
	IconRotateClockwise,
	IconTableImport,
	IconTrashX,
	IconX,
} from '@tabler/icons';

enum Action {
	IMPORT = 'IMPORT',
	EXPORT = 'EXPORT',
	CREATE = 'CREATE',
	BULKCREATE = 'BULKCREATE',
	UPDATE = 'UPDATE',
	DELETE = 'DELETE',
	LOGIN = 'LOGIN',
	LOGOUT = 'LOGOUT',
	ERROR = 'ERROR',
	DEFAULT = 'DEFAULT',
}

const iconMap = {
	[Action.DEFAULT]: IconFilePlus,
	[Action.LOGIN]: IconLogin,
	[Action.LOGOUT]: IconLogout,
	[Action.EXPORT]: IconDownload,
	[Action.IMPORT]: IconTableImport,
	[Action.CREATE]: IconPlus,
	[Action.BULKCREATE]: IconTableImport,
	[Action.UPDATE]: IconRotateClockwise,
	[Action.DELETE]: IconTrashX,
	[Action.ERROR]: IconX,
};

const actionColorMap = {
	[Action.DEFAULT]: 'gray.500',
	[Action.LOGIN]: 'green.500',
	[Action.LOGOUT]: 'gray.500',
	[Action.EXPORT]: 'blue.500',
	[Action.IMPORT]: 'green.500',
	[Action.CREATE]: 'green.500',
	[Action.BULKCREATE]: 'green.500',
	[Action.UPDATE]: 'orange.500',
	[Action.DELETE]: 'easyRED.300',
	[Action.ERROR]: 'easyRED.300',
};

const getErrorDescription = (original: string): string => {
	return original.replace(/^Importou\s+(.+)$/i, 'Falha na importação de $1');
};

export const LogActionIcon = props => {
	const { row } = props;
	const textColor = useColorModeValue('secondaryGray.900', 'white');

	const action = row.status === 'ERROR' ? Action.ERROR : row.acao;
	const IconComponent = iconMap[action] || iconMap[Action.DEFAULT];
	const iconColor = actionColorMap[action] || actionColorMap[Action.DEFAULT];

	const description =
		row.status === 'ERROR'
			? getErrorDescription(row.descricaoAtividade)
			: row.descricaoAtividade;

	return (
		<Flex>
			<Box display='flex'>
				<Icon
					as={IconComponent as any}
					w={6}
					h={6}
					color={iconColor}
				/>
			</Box>

			<Text
				color={textColor}
				fontSize='sm'
				fontWeight='700'
				pl='.5em'
			>
				{description}
			</Text>
		</Flex>
	);
};
